// extracted by mini-css-extract-plugin
export var integrationButton = "_7g-0";